var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSectionTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167 0V167H0V95.4261H23.858V143.142H143.142V0H167Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0V23.6724H24.0012V71H0V0H120Z",
    fill: "#00A44F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9961 72V95.9942H120V120H48V48H120C120 57.3726 120 62.6274 120 72H71.9961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSectionTwo);
export default __webpack_public_path__ + "static/media/LogoSectionTwo.1baa9301c289f72024e72ad3dc4b5732.svg";
export { ForwardRef as ReactComponent };